export const additionalEvaluationOptions = [
  /**
   * This const is used for the nullable very-little to very evaluations
   * done in the different sections of the admissions process.
   */
  {
    value: '',
    label: '-------',
  },
  {
    value: 'VERY_LITTLE',
    label: 'Veldig lite',
  },
  {
    value: 'LITTLE',
    label: 'Litt',
  },
  {
    value: 'MEDIUM',
    label: 'Middels',
  },
  {
    value: 'SOMEWHAT',
    label: 'Noe',
  },
  {
    value: 'VERY',
    label: 'Veldig',
  },
]
